import { FaPiggyBank } from "react-icons/fa";
import { defineType } from "sanity";

export default defineType({
  name: "signupForOffersThankYou",
  title: "Signup for Offers - Thank you page",
  icon: FaPiggyBank,
  type: "document",
  groups: [
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "subtitle",
      title: "Subtitle",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "metadata",
      title: "SEO, Routing & Tracking",
      type: "metadata",
      group: "seo"
    }
  ],

  preview: {
    prepare(value) {
      return {
        title: "Signup for Offers - Thank you page"
      };
    }
  }
});
